// App.jsx
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import CaseStudies from "./components/CaseStudies";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollToHash from "./components/ScrollToHash";

// Dynamic service page
import ServicePage from "./pages/ServicePage";

export default function App() {
  return (
    <>
      <Navbar />
      {/* Scroll handler for hash links */}
      <ScrollToHash />

      <Routes>
        {/* Homepage */}
        <Route
          path="/"
          element={
            <div className="bg-[#0f111a] text-white">
              <div id="home"><Hero /></div>
              <div id="about"><About /></div>
              <div id="services"><Services /></div>
              <div id="case-studies"><CaseStudies /></div>
              <div id="testimonials"><Testimonials /></div>
              <div id="contact"><Contact /></div>
              <Footer />
            </div>
          }
        />

        {/* Dynamic service pages */}
        <Route path="/services/:serviceId" element={<ServicePage />} />
      </Routes>
    </>
  );
}
